import { Controller } from "@hotwired/stimulus"

// reCAPTCHA v3 est invisible (un score, pas de case à cocher), mais le jeton doit
// être demandé (grecaptcha.execute) juste avant l'envoi : il est à usage unique et
// lié à un nom d'action. On intercepte donc l'envoi, on récupère un jeton, on le
// pose dans le champ caché, puis on envoie pour de bon.
//
// Usage : voir RecaptchaHelper (recaptcha_form_data + recaptcha_token_field).
//
// Le script de Google (api.js) est la seule exception à la règle « rien depuis un
// CDN » : reCAPTCHA est un service de vérification en ligne, pas une bibliothèque
// que l'on pourrait héberger.
export default class extends Controller {
  static targets = ["tokenField"]
  static values = { action: String, siteKey: String }

  handleSubmit(event) {
    if (this.submitting) return // jeton déjà obtenu : ce second envoi passe
    if (typeof window.grecaptcha === "undefined") return // script absent ou bloqué : le serveur tranchera

    event.preventDefault()
    const submitter = event.submitter
    window.grecaptcha.ready(() => {
      // Sans jeton (clé refusée, service injoignable), on envoie quand même : le
      // serveur répondra par le message d'échec plutôt que de laisser le bouton inerte.
      Promise.resolve()
        .then(() => window.grecaptcha.execute(this.siteKeyValue, { action: this.actionValue }))
        .catch(() => "")
        .then((token) => this.submit(token, submitter))
    })
  }

  submit(token, submitter) {
    this.tokenFieldTarget.value = token
    this.submitting = true
    this.element.requestSubmit(submitter)
    this.submitting = false // un nouvel envoi (après une erreur) redemandera un jeton
  }
}
